<section id="wrapper-carousel" Pagination (goTo)="onPaginate.emit($event)" [isEnd]="isEnd"
         [disable-when-fetch-data]="isLoading">
  <div class="container">
    <div class="slider-wrapper">
      <ng-template ngFor [ngForOf]="items" let-item let-idx="index">
        <div class="item">
          <div (click)="navigate(item.identifier, item.title, item)" class="container-img">
            <ng-template [ngIf]="item?.subscriptionStatus?.isSubscriptionConsumption">
              <div class="navaar-logo-icon-show-subscription">
                <navaar-logo-simple-icon></navaar-logo-simple-icon>
              </div>
            </ng-template>
            <img src="assets/img/placeholder.png"
                 [lazySrc]="BASE_HREF_IMAGE + '/content/books/' + item.audioBookId + '/pic.jpg?w=250&h=250&mode=stretch&t=' + item.recordVersion "
                 lazySrcVisible="visible" loading="lazy" class="wrapper-img-slider">
          </div>
          <div (click)="navigate(item.identifier, item.title, item)" class="container-desc">
            <h2 class="truncate">
              <span [textContent]="item.title"></span>
            </h2>
            <p class="truncate" *ngIf="item.authors.length > 0">
              <span [textContent]="item.authors[0].firstName + ' ' + item.authors[0].lastName"></span>
            </p>
            <p class="truncate" *ngIf="item.narrators.length > 0">
              <span [textContent]="item.narrators[0].firstName + ' ' + item.narrators[0].lastName"></span>
            </p>
          </div>
          <span class="context-menu-icon"
                (click)="onShowContextMenu($event,{ identifier: item.identifier, audiobookId: item.audioBookId, title: item.title, subscriptionStatus: item.subscriptionStatus })">
                <navaar-more-vert-icon></navaar-more-vert-icon>
            </span>
          <div class="duration-container">
            <ng-template
              [ngIf]="item.subscriptionStatus !== null ? (item.subscriptionStatus.isSubscriptionConsumption && item.subscriptionStatus.isExpired) : false">
              <navaar-lock-icon [width]="'10px'" [color]="'#ff6700'"></navaar-lock-icon>
              &nbsp;&nbsp;
              &nbsp;&nbsp;
            </ng-template>
            <span>مانده &nbsp;{{item.duration}}</span>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</section>

<navaar-context-menu-library
  (onRefresh)="onRefreshData()"
  [tab]="tabNameContextMenu"
  (OnClose)="onCloseContextMenu()"
  [isShow]="isShowContextMenuOption"
  [identifier]="identifierContextMenu"
  [audiobookTitle]="audiobookTitleContextMenu"
  [subscription-status]="subscriptionStatus"
  [audiobookId]="audiobookIdContextMenu"></navaar-context-menu-library>
